/**
 * 네이버 로그인 유틸리티
 */

const NAVER_CLIENT_ID = process.env.REACT_APP_NAVER_CLIENT_ID || ''
const NAVER_REDIRECT_URI = process.env.REACT_APP_NAVER_REDIRECT_URI || ''

/**
 * 네이버 로그인 실행 (현재 창에서 리다이렉트)
 */
export const handleNaverLogin = (): void => {
  if (!NAVER_CLIENT_ID || !NAVER_REDIRECT_URI) {
    alert('네이버 로그인 설정이 완료되지 않았습니다')
    return
  }

  const state = Math.random().toString(36).substring(2, 15)

  const naverLoginUrl = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${NAVER_CLIENT_ID}&redirect_uri=${encodeURIComponent(
    NAVER_REDIRECT_URI
  )}&state=${state}`

  window.location.href = naverLoginUrl
}

/**
 * 네이버 로그인 콜백 처리
 */
export const handleNaverCallback = async (
  code: string,
  state: string,
  onSuccess: (providerId: string) => Promise<void>,
  onError: (error: string) => void
): Promise<void> => {
  try {
    const { authApi } = await import('../api/auth')
    const response = await authApi.naverCallback(code, state)

    if (!response || !response.provider_id) {
      onError('네이버 사용자 정보를 가져올 수 없습니다')
      return
    }

    await onSuccess(response.provider_id)
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      '네이버 로그인 중 오류가 발생했습니다'
    onError(errorMessage)
  }
}
